module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-vod-12-years.e57f88d0.svg";